/**
 * HTML input types
 *
 * @see https://www.w3schools.com/tags/att_input_type.asp
 */
export const HTML_INPUT_TYPE = {
  BUTTON: 'button',
  CHECKBOX: 'checkbox',
  COLOR: 'color',
  DATE: 'date',
  DATETIME: 'datetime-local',
  EMAIL: 'email',
  FILE: 'file',
  HIDDEN: 'hidden',
  IMAGE: 'image',
  MONTH: 'month',
  NUMBER: 'number',
  PASSWORD: 'password',
  RADIO: 'radio',
  RANGE: 'range',
  RESET: 'reset',
  SEARCH: 'search',
  SUBMIT: 'submit',
  TEL: 'tel',
  TEXT: 'text',
  TIME: 'time',
  URL: 'url',
  WEEK: 'week',
};
export type HTML_INPUT_TYPE = typeof HTML_INPUT_TYPE;
export type AN_HTML_INPUT_TYPE = HTML_INPUT_TYPE[keyof HTML_INPUT_TYPE];
